import { useLocalStorage } from "src/core/local-storage/hooks/useLocalStorage";
import { WalletProvider, DeprecatedMoneyButtonProvider } from "src/core/wallet/wallet.model";
import { LocalStorageKey } from "src/core/local-storage/local-storage.model";

/**
 * Setting WalletProvider means we're either login in or are logged in with said Wallet Provider
 */
export function useWalletProvider() {
    return useLocalStorage<WalletProvider | DeprecatedMoneyButtonProvider | null>(LocalStorageKey.WalletProvider, null);
}